<template>
  <div class="f-v f-ast">
    <donut-modal-sections-title title="Are you sure you want to delete this bonus event?" />
    <div class="t">You will no longer be able to send bonus {{ $i18n.t('shoutouts.point', { count: 2 }) }} for the {{ eventTemplate.title }} event.</div>
    <donut-modal-sections-actions
      button-text="Delete"
      save-action="bonusEventTemplates/deleteEventTemplate"
      :save-args="{ eventTemplate }"
      :loading-on-save="true"
    />
  </div>
</template>

<script setup>
  import { inject } from 'vue';
  import { useStore } from 'vuex';

  const $i18n = inject('$i18n');
  const { state } = useStore();

  const { eventTemplate } = state.modal.data;
</script>
